/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParcelImgVo
 */
export interface ParcelImgVo {
    /**
     * 快递图片
     * @type {string}
     * @memberof ParcelImgVo
     */
    fileUrl?: string;
    /**
     * 快递图片id
     * @type {number}
     * @memberof ParcelImgVo
     */
    id?: number;
}

/**
 * Check if a given object implements the ParcelImgVo interface.
 */
export function instanceOfParcelImgVo(value: object): value is ParcelImgVo {
    return true;
}

export function ParcelImgVoFromJSON(json: any): ParcelImgVo {
    return ParcelImgVoFromJSONTyped(json, false);
}

export function ParcelImgVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParcelImgVo {
    if (json == null) {
        return json;
    }
    return {
        
        'fileUrl': json['fileUrl'] == null ? undefined : json['fileUrl'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function ParcelImgVoToJSON(json: any): ParcelImgVo {
    return ParcelImgVoToJSONTyped(json, false);
}

export function ParcelImgVoToJSONTyped(value?: ParcelImgVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileUrl': value['fileUrl'],
        'id': value['id'],
    };
}

